import { render, staticRenderFns } from "./feature-edit-confirm.vue?vue&type=template&id=6a66f839"
import script from "./feature-edit-confirm.vue?vue&type=script&lang=js"
export * from "./feature-edit-confirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports